import { fetchApi } from '@/services/api-client';

export const TEMPERATURE_PATH = '/admin/temperature';

export type TemperatureReading = {
  id: string;
  tempC: number;
  measuredAt: string;
  takenByName: string;
  note: string | null;
};

export type TemperatureStudentEntry = {
  studentId: string;
  displayName: string;
  fullName: string;
  gradeLevel: number | null;
  photoUrl: string | null;
  readings: TemperatureReading[];
};

export type TemperatureRosterResponse = {
  class: { id: string; name: string; gradeLevel: number | null };
  students: TemperatureStudentEntry[];
};

export type AddTemperatureReadingBody = {
  studentId: string;
  classId: string;
  date: string;
  tempC: number;
  note?: string;
};

export type UpdateTemperatureReadingBody = {
  tempC?: number;
  note?: string;
  measuredAt?: string;
};

export type StudentTemperatureReading = {
  id: string;
  date: string;
  tempC: number;
  measuredAt: string;
  takenByName: string | null;
  note: string | null;
};

export type TemperatureExportReading = {
  tempC: number;
  measuredAt: string;
  fever: boolean;
};

export type TemperatureExportRow = {
  date: string;
  className: string;
  studentDisplayName: string;
  gradeLevel: number | null;
  readings: TemperatureExportReading[];
};

export type TemperatureExportParams = {
  from: string;
  to: string;
  classIds: string[];
};

export const temperatureApi = {
  roster: (classId: string, date: string) => {
    const qs = new URLSearchParams({ classId, date });
    return fetchApi<TemperatureRosterResponse>(`${TEMPERATURE_PATH}/roster?${qs.toString()}`);
  },

  export: ({ from, to, classIds }: TemperatureExportParams) => {
    const qs = new URLSearchParams({ from, to, classIds: classIds.join(',') });
    return fetchApi<TemperatureExportRow[]>(`${TEMPERATURE_PATH}/export?${qs.toString()}`);
  },

  addReading: (data: AddTemperatureReadingBody) =>
    fetchApi<TemperatureReading>(`${TEMPERATURE_PATH}/reading`, {
      method: 'POST',
      body: JSON.stringify(data),
    }),

  deleteReading: (id: string) =>
    fetchApi<{ success: boolean }>(`${TEMPERATURE_PATH}/reading/${id}`, { method: 'DELETE' }),

  // Note: this hits the attendance module's route, not TEMPERATURE_PATH.
  updateReading: (id: string, data: UpdateTemperatureReadingBody) =>
    fetchApi<TemperatureReading>(`/admin/attendance/temperature/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(data),
    }),

  listForStudent: (studentId: string) => fetchApi<StudentTemperatureReading[]>(`/students/${studentId}/temperature`),
};
